<template>
  <div id="app">
    <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
    <!-- <HelloWorld msg="Welcome to YourFlix App"/> -->
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'app'
}
</script>

<style>

</style>
